import type { ReactElement } from 'react'

import { Filter } from './Filter'
import { NewsList } from './NewsList'
import { SectionTitle } from '@/components/elements/SectionTitle'
import { Spacer } from '@/components/elements/Spacer'
import { TitleLayout } from '@/components/layout'
import { Head } from '@/components/layouts/Head'
import { Layout } from '@/components/layouts/Ir'

import { useMpocketScript } from '@/hooks/useMpocketScript'

export const NewsPage = () => {
  useMpocketScript('//irpocket.com/141A/irpocket/ir-news.js')
  // useMpocketScript('//irpocket.com/5882/irpocket/ir-news.js')

  // 初期状態は「すべて」がアクティブ
  const tagList = [
    { name: 'すべて', filterId: 'all', isActive: true },
    { name: 'お知らせ', filterId: 'oshirase', isActive: false },
    { name: '決算関連', filterId: 'kessan', isActive: false },
    { name: '株主総会', filterId: 'sokai', isActive: false },
  ]

  return (
    <Layout>
      <SectionTitle
        titleText="IR News"
        subTitleText="IRニュース"
        color="normal"
      />
      <Spacer h={{ sp: 50, pc: 50 }} />
      <Filter tagList={tagList} />
      <Spacer h={{ sp: 40, pc: 80 }} />
      <NewsList />
    </Layout>
  )
}

NewsPage.getLayout = (page: ReactElement) => {
  const breadCrumbs = [
    { name: 'ホーム', path: '/' },
    { name: '株主・投資家向け情報', path: '/ir' },
    { name: 'IRニュース', path: '' },
  ]

  return (
    <>
      <Head
        title="IRニュース"
        description="トライアルホールディングスのIR情報に関する最新情報を掲載しています。"
        ogp={{ url: 'ir/news/' }}
      />
      <TitleLayout
        title="Investor Relations"
        subTitle="株主・投資家向け情報"
        breadCrumbs={breadCrumbs}
      >
        {page}
      </TitleLayout>
    </>
  )
}
